<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent scrollable>
      <v-card tile>
        <v-toolbar dark color="primary" dense flat class="max-height">
          <v-spacer></v-spacer>
          <v-toolbar-title class="white--text"> Cambio de Programa </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text>
          <template>
            <v-stepper v-model="steper" vertical>
              <!-- ---------SELECT SEDE------------- -->
              <v-stepper-step editable :complete="steper > 1" step="1">
                Sede Destino
                <small>Seleccione la sede de destino, por defecto es la sede del programa</small>
              </v-stepper-step>

              <v-stepper-content step="1">
                <v-card elevation="0">
                  <h4>La sede Destino debe tener el programa de la misma area, categoria y gestion</h4>
                  <v-select
                    v-model="sede_destino"
                    :items="sedes"
                    item-text="nombre"
                    outlined
                    clearable
                    return-object
                    label="Sede de Destino"
                  ></v-select>
                  <v-card-actions>
                    <v-btn rounded outlined @click="closeDialog">
                      Cancelar <v-icon class="mx-1">mdi-close</v-icon>
                    </v-btn>
                    <v-btn rounded :disabled="!sede_destino" class="mx-2" color="primary" @click="steper = 2">
                      Siguiente
                      <v-icon class="mx-1">mdi-chevron-double-right</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-stepper-content>
              <!-- ----------SELECT PROGRAMA DESTINO------------ -->
              <v-stepper-step :complete="steper > 2" step="2"> Seleccione el Programa destino </v-stepper-step>
              <v-stepper-content step="2">
                <v-card elevation="0">
                  <h4 class="red--text">Solo se puede cambiar a programas de la misma area y categoria</h4>
                  <v-row class="pl-3" v-if="programa">
                    <v-col cols="6" xs="12" class="ma-0 pa-1">
                      <span class="font-weight-bold">Categoria: </span>
                      {{ programa.postgrado.categoria.nombre }}
                    </v-col>
                    <v-col cols="6" xs="12" class="ma-0 pa-1">
                      <span class="font-weight-bold">Area: </span>
                      {{ programa.postgrado.area.nombre }}
                    </v-col>
                    <v-col cols="6" xs="12" class="ma-0 pa-1">
                      <span class="font-weight-bold">Gestion: </span>
                      {{ programa.gestion }}
                    </v-col>
                    <v-col cols="6" xs="12" class="ma-0 pa-1">
                      <span class="font-weight-bold">Version: </span>
                      {{ programa.version }}
                    </v-col>
                  </v-row>
                  <v-select
                    v-model="program_destino"
                    :items="programas_disponibles"
                    item-text="nombre_compuesto"
                    outlined
                    clearable
                    return-object
                    label="Programas Disponiles"
                  ></v-select>
                  <v-card-actions>
                    <v-btn rounded outlined @click="steper = 1">
                      <v-icon class="mx-1">mdi-chevron-double-left</v-icon>
                      Anterior
                    </v-btn>
                    <v-btn rounded :disabled="!program_destino" class="mx-2" color="primary" @click="steper = 3">
                      Siguiente
                      <v-icon class="mx-1">mdi-chevron-double-right</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-stepper-content>
              <!-- ---------SELECT PLAN PAGOS DESTINO------------- -->
              <v-stepper-step :complete="steper > 3" step="3"> Seleccione el Nuevo plan destino </v-stepper-step>
              <v-stepper-content step="3">
                <v-card class="mb-10" elevation="0">
                  <v-card-text>
                    <h4>Solo estan disponibles los planes activos</h4>
                    <v-select
                      v-model="plan_destino"
                      dense
                      outlined
                      :items="planes_disponibles"
                      clearable
                      return-object
                      item-text="nombre"
                      label="Planes Disponibles"
                    ></v-select>

                    <v-row v-if="inscripcion && plan_destino" justify="center">
                      <v-col xs="12" sm="6" md="6">
                        <v-data-table
                          :headers="headPlanCobro"
                          hide-default-footer
                          disable-pagination
                          :items="inscripcion.plan_programa.cobros_programa"
                          class="elevation-5"
                        >
                          <template v-slot:top>
                            <p class="h3 text-center pt-2 text-primary">PLAN ANTERIOR</p>
                            <p class="h4 text-center font-weight-bold amber--text">
                              {{ inscripcion.plan_programa.nombre }}
                              <v-tooltip bottom>
                                <template #activator="{ on, attrs }">
                                  <v-icon v-on="on" v-bind="attrs" @click="showMoreDetails">mdi-eye</v-icon>
                                </template>
                                Mas detalle
                              </v-tooltip>
                            </p>
                          </template>
                        </v-data-table>
                        <v-card min-width="100%" class="mt-2 elevation-10">
                          <p>
                            <span class="px-2 font-weight-bold red--text">Monto Total:</span>
                            {{ inscripcion.monto_total }} bs.
                          </p>
                          <p>
                            <span class="px-2 font-weight-bold red--text">Monto Cancelado:</span>
                            {{ inscripcion.monto_cancelado }} bs.
                          </p>
                          <p>
                            <span class="px-2 font-weight-bold red--text">Saldo Restante:</span>
                            {{ inscripcion.monto_saldo }} bs.
                          </p>
                          <p>
                            <span class="px-2 font-weight-bold"> monto a liquidar </span>
                            {{ inscripcion.monto_saldo }} bs.
                          </p>
                        </v-card>
                      </v-col>
                      <v-col xs="12" sm="6" md="6">
                        <v-data-table
                          :headers="headPlanCobro"
                          hide-default-footer
                          disable-pagination
                          :items="plan_destino.cobros_programa"
                          class="elevation-5"
                        >
                          <template v-slot:top>
                            <p class="h3 text-center pt-2 text-primary">NUEVO PLAN</p>
                            <p class="h4 text-center font-weight-bold amber--text">
                              {{ plan_destino.nombre }}
                            </p>
                          </template>
                        </v-data-table>
                        <v-card min-width="100%" class="mt-2 elevation-10">
                          <p>
                            <span class="px-1 font-weight-bold red--text">Total a Pagar:</span>
                            {{ plan_destino.monto_total }} bs.
                          </p>
                          <p>
                            <span class="px-1 font-weight-bold red--text">Monto a Compensar:</span>
                            {{ inscripcion.monto_cancelado }} bs.
                          </p>
                          <p>
                            <span class="px-1 font-weight-bold red--text">Saldo Restante:</span>
                            {{ plan_destino.monto_total - inscripcion.monto_cancelado }}
                            bs.
                          </p>
                          <p>
                            <span class="px-1 font-weight-bold"> Monto a Compensar </span>
                            {{ inscripcion.monto_cancelado }} bs.
                          </p>
                        </v-card>
                      </v-col>
                      <v-col v-if="inscripcion.monto_cancelado >= plan_destino.monto_total" class="pb-0 mb-0">
                        <p class="text-center px-1 font-weight-bold red--text">
                          no se puede cambiar a un plan donde el monto total del destino es menor al monto ya cancelado
                          en el plan anterior
                        </p>
                      </v-col>
                    </v-row>
                    <plan-pagos-details ref="refPlaPagosDetail" />
                  </v-card-text>
                  <v-card-actions>
                    <v-btn rounded outlined @click="steper = 2">
                      <v-icon class="mx-1">mdi-chevron-double-left</v-icon>
                      Anterior
                    </v-btn>
                    <v-btn
                      v-if="plan_destino && inscripcion && inscripcion.monto_cancelado < plan_destino.monto_total"
                      rounded
                      :disabled="!plan_destino"
                      class="mx-2"
                      color="primary"
                      @click="steper = 4"
                    >
                      Siguiente
                      <v-icon class="mx-1">mdi-chevron-double-right</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-stepper-content>
              <!-- ---------------------- -->
              <v-stepper-step step="4"> Detalle de Cambio</v-stepper-step>
              <v-stepper-content step="4">
                <v-card>
                  <v-card-text v-if="plan_destino">
                    <v-row>
                      <v-col xs="12" sm="6" md="6">
                        <v-data-table
                          :headers="headPlanCobro"
                          hide-default-footer
                          disable-pagination
                          :items="inscripcion.plan_programa.cobros_programa"
                          class="elevation-5"
                        >
                          <template v-slot:top>
                            <p class="h3 text-center pt-2 text-primary">PLAN ANTERIOR</p>
                            <p class="h4 text-center font-weight-bold amber--text">
                              {{ inscripcion.plan_programa.nombre }}
                            </p>
                          </template>
                        </v-data-table>
                      </v-col>
                      <v-col xs="12" sm="6" md="6">
                        <v-data-table
                          :headers="headPlanCobro"
                          hide-default-footer
                          disable-pagination
                          :items="plan_destino.cobros_programa"
                          class="elevation-5"
                        >
                          <template v-slot:top>
                            <p class="h3 text-center pt-2 text-primary">NUEVO PLAN</p>
                            <p class="h4 text-center font-weight-bold amber--text">
                              {{ plan_destino.nombre }}
                            </p>
                          </template>
                          <template v-slot:item.cuotas="{ item }">
                            <v-text-field
                              class="w-100"
                              type="number"
                              v-model.number="item.cuotas"
                              @change="reload_new_plan(plan_destino)"
                              outlined
                              dense
                            ></v-text-field>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col xs="12" sm="6" md="6">
                        <v-data-table
                          :headers="headPlanPagos"
                          hide-default-footer
                          disable-pagination
                          :items="inscripcion.plan_pagos"
                          class="elevation-5"
                        >
                          <template v-slot:top>
                            <p class="h3 text-center pt-2 text-primary">CUOTAS PAGADAS</p></template
                          >
                        </v-data-table>
                      </v-col>
                      <v-col xs="12" sm="6" md="6">
                        <v-data-table
                          :headers="headPlanPagosDestino"
                          hide-default-footer
                          disable-pagination
                          :items="plan_pagos_detail"
                          class="elevation-5"
                        >
                          <template v-slot:top>
                            <p class="h3 text-center pt-2 text-primary">CUOTAS POR PAGAR</p>
                          </template>
                        </v-data-table>
                      </v-col>
                      <v-col>
                        <v-select
                          v-model="motivo"
                          :items="motivos"
                          item-text="descripcion"
                          :rules="[(v) => !!v || 'campo obligatorio']"
                          outlined
                          clearable
                          return-object
                          label="Motivo"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn rounded outlined @click="steper = 3">
                      <v-icon class="mx-1">mdi-chevron-double-left</v-icon>
                      Anterior
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-stepper-content>
            </v-stepper>
          </template>

          <p class="text-center red--text">{{ msg }}</p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="
              steper == 4 &&
                plan_destino &&
                inscripcion &&
                inscripcion.monto_cancelado < plan_destino.monto_total &&
                motivo
            "
            rounded
            class="mx-2"
            color="primary"
            @click="saveChange()"
          >
            Guardar Y Finalizar
          </v-btn>
          <v-btn color="blue darken-1" outlined rounded @click="closeDialog">
            Cancelar Cambio <v-icon class="mx-2"> mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <kardex-pagos v-bind.sync="oneCuota" ref="refKardex"></kardex-pagos> -->
  </v-row>
</template>

<script>
  import xaxios from '@/xaxios';
  import gql from 'graphql-tag';
  import { mapState } from 'vuex';
  import { formatDate } from '@/components/Utils.js';
  import PlanPagosDetails from '../Inscripcion/PlanPagosDetails.vue';
  export default {
    components: { PlanPagosDetails },
    data() {
      return {
        api_rest: process.env.VUE_APP_API_REST,
        steper: 1,
        inscripcion_id: '',
        dialog: false,
        inscripcion: null,
        recibos: [],
        sede_destino: null,
        programas_disponibles: [],
        program_destino: null,
        programa_temp: null,
        planes_disponibles: [],
        plan_destino: null,
        plan_pagos_detail: [],
        motivo: null,
        motivos: [],
        sedes: [],
        msg: '',
        headPlanCobro: [
          { text: 'Nombre', value: 'concepto_pago.nombre' },
          { text: 'Monto', value: 'monto' },
          { text: 'Cuotas', value: 'cuotas' },
        ],
        headPlanPagos: [
          // { text: 'Codigo-Cuota', value: 'id' },
          { text: 'Concepto', value: 'concepto_pago.nombre' },
          { text: 'Cuota', value: 'nro_cuota' },
          { text: 'Monto', value: 'monto' },
          { text: 'Descuento', value: 'descuento' },
          { text: 'Saldo', value: 'saldo' },
          { text: 'fecha_pago', value: 'date_pago' },
        ],
        headPlanPagosDestino: [
          // { text: 'Codigo-Cuota', value: 'id' },
          { text: 'Concepto', value: 'concepto_pago.nombre' },
          { text: 'Cuota', value: 'nro_cuota' },
          { text: 'Monto', value: 'monto' },
          // { text: 'Descuento', value: 'descuento' },
          // { text: 'Saldo', value: 'saldo' },
          { text: 'fecha_pago', value: 'fecha_pago' },
        ],
        headProgramas: [
          { text: 'Codigo', value: 'programa.programa_id' },
          { text: 'Programa', value: 'programa.nombre_compuesto' },
        ],
      };
    },
    watch: {
      dialog(val) {
        if(val) this.getSedes();
        val || this.closeDialog();
      },
      sede_destino(value) {
        void this.cambiosedeprograma(value)
      },
      async program_destino(value) {
        this.plan_destino = null;
        this.planes_disponibles = [];
        if (value) {
          window.console.log('cargando planes....');
          this.programa_temp = await this.$apollo
            .query({
              query: gql`query{getPrograma(id:${value.id}){id,nombre_compuesto,version,grupo,
            postgrado{area{id,nombre},categoria{id,nombre},id,nombre},
            planes{id,nombre,estado,cobros_programa{id,monto,cuotas,estado,concepto_pago{id,nombre}}}
          }}`,
            })
            .then(({ data: { getPrograma } }) => getPrograma)
            .catch(() => {});
          this.programa_temp.planes = this.programa_temp.planes.filter((x) => {
            return x.estado;
          });
          this.planes_disponibles = this.programa_temp.planes;
          window.console.log('planes disponibles: >>', this.planes_disponibles);
        }
      },
      plan_destino(value) {
        if (value) {
          this.reload_new_plan(value);
        }
      },
    },
    computed: {
      ...mapState({
        UNIDAD_NEGOCIO_ID: (state) => state.UNIDAD_NEGOCIO_ID,
        sede_id: (state) => state.CARGO.sede.id,
        gestion: (state) => state.gestion.value.gestion,
        // sedes: (state) => state.modsede.items.filter((item) => item.unidad_negocio == state.UNIDAD_NEGOCIO_ID),
        programa: (state) => state.programa.value,
        all_programs: (state) => state.programa.items.filter((item) => item.estado),
      }),
    },
    methods: {  
      async cambiosedeprograma(value){
        this.program_destino = null;
        this.programas_disponibles = []; 
        if (value) {
          let sql = gql`query{ getProgramas(cursor:1000000,estado:true,idsede:${value.id}){ id,plataforma_id, course_category_id,fase,version,grupo,estado,codigo,nombre_compuesto, sede{id nombre}} }`;
          const res = await this.$apollo.query({ query: sql, variables: {} }).then(({data})=>data).catch((e) => e)
          window.console.log('>>>>resss cambio', res);
          
          const progs = res && res.getProgramas? res.getProgramas : this.all_programs
          window.console.log('>>>>resss progs', progs);
          
          this.programas_disponibles = progs
            .filter((item) => item.id != this.programa.id)
            .filter((item) => item.sede.id === value.id)
            //.filter((item) => item.postgrado.categoria.id === this.programa.postgrado.categoria.id)
            //.filter((item) => item.postgrado.area.id === this.programa.postgrado.area.id)
            // .filter((item) => item.gestion === this.programa.gestion)
            // .filter((item) => item.version === this.programa.version)
            .map((item) => item);
          this.programas_disponibles = this.programas_disponibles.map((item) => ({
            ...item,
            nombre_compuesto: `${item.codigo} ${item.nombre_compuesto}`,
          }));
        }
      },
      async saveChange() {
        const compensacionData = {
          descripcion: 'compensacion por cambio de programa',
          inscripcion: {
            asesor_id: this.inscripcion.idasesor,
            estudiante_id: this.inscripcion.idestudiante,
            observaciones: 'estudiante cambiando desde el programa ' + this.program_destino.id,
            plan_cobro_programa_id: this.plan_destino.id,
            plan_pagos: [...this.plan_pagos_detail],
            programa_id: this.program_destino.id,
            registrado_por: this.inscripcion.registrado_por,
            tipo_pago: true,
          },
          inscripcion_antigua_id: this.inscripcion.id,
          monto: this.inscripcion.monto_cancelado,
          motivo_id: this.motivo.id,
        };
        const vue = this;
        this.msg = '';
        window.console.log(JSON.stringify(compensacionData, null, 4));
        await xaxios
          .post(`${this.api_rest}/api/v1/inscripcion/pagos/compensacion`, compensacionData)
          .then(({ data }) => {
            this.$root.$notify.show(`El Estudiante fue cambiado de programa correctamente`, { color: 'primary' });
            this.closeDialog();
            this.$emit('onchangeprograma',this.inscripcion.id);
            return data;
          })
          .catch((error) => {
            window.console.error(error, error.response);
            if (error.response) {
              vue.msg = error.response.data.data;
            }
            vue.msg = error.response.data.data;
            //window.console.log(JSON.stringify(error));
            return null;
          });

        /////await axios.post(`${this.api_rest}/api/v1/inscripcion/pagos/compensacion`, compensacionData).then(() => {
          // window.console.log('programa cambiado', JSON.stringify(data));
          ///this.$root.$notify.show(`El Estudiante fue cambiado de programa correctamente`, { color: 'primary' });
        //});/////
        //this.closeDialog();
      },
      async getSedes() {
          const idunidad = this.$store.state.CARGO.sede.unidad_negocio;
          const qs = gql` query {getSedes ${''} {id, nombre,unidad_negocio}}`;
          let s = await this.$apollo.query({ query: qs })
            .then(({ data: { getSedes } }) => getSedes.length ? getSedes:[]).catch(() => []);
          s = s.filter(s=>s.unidad_negocio==idunidad)
          this.sedes = s;
        },
      calculateDate(date, months = 0) {
        let newDate = new Date(date);
        if (months >= 1) {
          newDate = new Date(newDate.setMonth(newDate.getMonth() + months));
        }
        return newDate.toISOString().slice(0, 10);
      },
      reload_new_plan(value) {
        // window.console.log('executed', value);
        value.monto_total = 0;
        // let pp = this.inscripcion.plan_pagos.filter((pp) => pp.saldo != pp.monto);
        this.plan_pagos_detail = [];
        if (value && value.cobros_programa.length) {
          let date = this.inscripcion.plan_pagos[0].fecha_pago || new Date();
          value.cobros_programa.forEach((concepto) => {
            value.monto_total += concepto.monto;
            let submonto = parseInt(concepto.monto / concepto.cuotas);

            for (let i = 1; i <= concepto.cuotas; i++) {
              let monto = i === 1 ? concepto.monto - submonto * concepto.cuotas + submonto : submonto;
              this.plan_pagos_detail.push({
                cobro_programa_id: concepto.id,
                concepto_pago: concepto.concepto_pago,
                concepto_pago_id: concepto.concepto_pago.id,
                nro_cuota: i,
                monto: monto,
                saldo: monto,
                date_pago: this.calculateDate(date, i),
                fecha_pago: formatDate(this.calculateDate(date, i)),
                estado: concepto.estado,
              });
            }
          });
          // window.console.log(this.plan_pagos_detail.length);
        }
      },
      async showThisView(inscripcion_id) {
        this.inscripcion_id = inscripcion_id;
        this.sede_destino = this.sedes.find((item) => (item.id = this.sede_id));
        const sql = gql`query{ getInscripcion(id:${inscripcion_id}){ id idestudiante idasesor registrado_por
         plan_programa{ id, nombre, cobros_programa{concepto_pago{nombre}monto, cuotas}}
         plan_pagos { id, monto, saldo, nro_cuota, descuento, fecha_pago, concepto_pago{nombre}}
         pagos_inscripcion{ nro_recibo, detalle_pago {concepto,monto}}
      }}`;
        this.inscripcion = await this.$apollo.query({ query: sql }).then(({ data }) => data.getInscripcion);
        this.inscripcion.plan_pagos = this.inscripcion.plan_pagos.map((cuota) => {
          cuota.date_pago = formatDate(cuota.fecha_pago);
          return cuota;
        });
        this.dialog = true;
        this.get_more_plan_pagos(inscripcion_id);
      },

      async get_more_plan_pagos(inscripcion_id) {
        this.inscripcion.detail_plan_pagos = await xaxios
          .get(`${this.api_rest}/api/v1/inscripcion/${inscripcion_id}/plan-pago`)
          .then(({ data: { data } }) =>
            data.length
              ? data.map((item) => ({
                  ...item,
                  date_pago: formatDate(item.fecha_pago),
                  monto_compensacion: Number(item.monto_compensacion),
                  monto_descuento: Number(item.monto_descuento),
                  monto_liquido: Number(item.monto_liquido),
                  monto_pagado: Number(item.monto_pagado),
                  monto_regularizado: Number(item.monto_regularizado),
                  total: Number(item.total),  
                }))
              : [],
          )
          .catch(() => []);

        this.inscripcion.monto_total = this.inscripcion.detail_plan_pagos.reduce(
          (total, item) => total + item.total,
          0,
        );
        this.inscripcion.monto_cancelado = this.inscripcion.detail_plan_pagos.reduce(
          (total, item) => total + item.monto_pagado,
          0,
        );
        this.inscripcion.monto_saldo = this.inscripcion.monto_total - this.inscripcion.monto_cancelado;
        // window.console.log(JSON.stringify(this.inscripcion.detail_plan_pagos));
      },
      get_data_invoices(inscripcion_id) {
        const url = `${this.api_rest}/api/pagos/recibos/buscar/inscripcion`;
        xaxios.post(url, { inscripcion_id }).then(({ data }) => (this.recibos = data ? data : []));
      },
      async getMotivos(un_id) {
        const url = `${this.api_rest}/api/v1/motivos?unidad_negocio_id=${un_id}&descuento_tipo_id=4&estado=true`;
        this.motivos = await xaxios
          .get(url)
          .then(({ data }) => data.data)
          .catch(() => []);
      },
      showMoreDetails() {
        this.$refs.refPlaPagosDetail.showThisView(this.inscripcion.detail_plan_pagos, null, this.inscripcion_id);
      },
      closeDialog() {
        this.dialog = false;
        this.$nextTick(() => {
          this.steper = 1;
          this.student = null;
          this.asesor = null;
          this.programa_temp = null;
          this.programas_disponibles = [];
          this.planes_disponibles = [];
          this.sede_destino = null;
          this.program_destino = null;
          this.plan_destino = null;
          this.motivo = null;
          // this.motivos = [];
          this.recibos = [];
        });
      },
    },
    mounted() {
      this.getMotivos(this.UNIDAD_NEGOCIO_ID);
    },
  };
</script>
<style>
  .max-height {
    max-height: 4.5em;
  }
  .mora-mes-1 {
    background-color: #fb706d78;
  }
  .mora-semana-1 {
    background-color: #ffe17694;
  }
  .regularizado {
    background-color: #0076fb5e;
  }
  .descuento {
    background-color: #08fb005e;
  }
</style>
